module.exports = __webpack_public_path__ + "img/CCLF_infographic-10.b769c579.png";